module.exports = __webpack_public_path__ + "img/quote.ec4dc1c9.svg";